import React, { useState, useEffect, createContext } from 'react'
import { useValue } from 'firebase-utils'

interface Props {
    children: React.ReactChild
}

/**
 * Context for accessing the helper functions provided by this context.
 */
export const SalesForceContext = createContext({})

/**
 * Loads and initialises the salesforce client library, and providers helper functions
 * to work with salesforce.
 */
const SalesForceProvider = (props: Props): JSX.Element => {
    const chatSettings = useValue('sales_force_chat_settings')
    const [chatReady, setChatReady] = useState(false)

    const onLibraryLoaded = () => {
        console.log('salesForceChatSettings:', typeof (chatSettings), chatSettings)

        let settings: any = {}
        if (typeof (chatSettings) === 'string') {
            try {
                settings = JSON.parse(chatSettings) // this comes from remote config as a string
            } catch (error) {
                console.error(error)
            }
        } else {
            settings = chatSettings
        }
        settings.snapInURL = `${settings.communityURL}/resource/phoneEinsteinBot/js/SnapInChat.js?${Date.now()}`

        console.log(`snapIn.js URL ${settings.snapInURL}`)
        const s = document.createElement('script')
        s.setAttribute('src', settings.snapInURL)
        s.onload = function () { window.initChat(settings) }
        document.body.appendChild(s)

        setChatReady(true)
    }

    useEffect(() => {
        const script = document.createElement('script')
        script.setAttribute('data-testid', 'salesforce-script')
        document.body.appendChild(script)
        script.onload = onLibraryLoaded
        script.src = 'https://service.force.com/embeddedservice/5.0/esw.min.js'

        return () => {
            document.body.removeChild(script)
        }
    }, [chatSettings])

    const openChat = () => {
        const sfChatElement = document.getElementsByClassName('embeddedServiceHelpButton')[0] as HTMLElement
        const sfChatOpenElement = document.querySelector('.embeddedServiceHelpButton .helpButton .helpButtonEnabled.uiButton') as HTMLElement
        if (!sfChatElement || !sfChatOpenElement) return
        sfChatElement.style.display = 'block'
        sfChatOpenElement.click()
    }

    return (
        <SalesForceContext.Provider
            value={{
                chatReady,
                openChat
            }}
        >
            {props.children}
        </SalesForceContext.Provider>
    )
}

export default SalesForceProvider
